import { baseUrl } from "../airport/apis";

const authBaseUrl =
  import.meta.env.VITE_AUTH_API_URL || `${import.meta.env.VITE_BASE_URL}/api/v1`;

export const loadClientUrl = `${authBaseUrl}/client`;
export const clientJoinUrl = `${authBaseUrl}/client/join`;
export const clientSocialJoinUrl = `${authBaseUrl}/client/join_auth`;
export const verifyClientUrl = `${authBaseUrl}/client/verify`;
export const updateClientUrl = `${authBaseUrl}/client/update`;

export const addPriceAlertUrl = `${authBaseUrl}/price-alert/create`;
export const loadPriceAlertUrl = `${authBaseUrl}/price-alert/all`;
export const unsubscribePriceAlertUrl = `${authBaseUrl}/price-alert/unsubscribe/`;
